import { useTheme } from "@/contexts/ThemeContext";
import { Sun, Moon } from "lucide-react";

/**
 * Pulsante per alternare tema scuro/chiaro. Icona sole in dark mode
 * (perché "se cliccato → diventa chiaro"), icona luna in light mode.
 */
export function ThemeToggle({ className = "" }) {
  const { theme, toggle } = useTheme();
  const Icon = theme === "dark" ? Sun : Moon;
  return (
    <button
      onClick={toggle}
      data-testid="theme-toggle-btn"
      title={theme === "dark" ? "Passa a tema chiaro" : "Passa a tema scuro"}
      className={
        `inline-flex items-center justify-center w-10 h-10 rounded-lg ` +
        `border border-white/10 bg-zinc-900/60 hover:bg-zinc-800 ` +
        `text-amber-400 hover:text-amber-300 transition-colors ${className}`
      }
    >
      <Icon className="w-5 h-5" />
    </button>
  );
}
